<template>
  <div style="width: 100%; height: 520px; overflow: auto">
    <div
      ref="lineChart"
      style="width: 100%; min-width: 600px; height: 100%"
    ></div>
  </div>
</template>

<script>
import * as echarts from "echarts";

export default {
  name: "LineChart",
  data() {
    return {
      typeXAxis: [],
      seriesData: [],
    };
  },
  mounted() {},
  methods: {
    initData(data) {
      this.typeXAxis = [];
      this.seriesData = [];
      data.forEach((item) => {
        this.typeXAxis = JSON.parse(item.axisXData);
        this.seriesData.push({
          name: item.platform == "WX" ? "微信" : "支付宝",
          type: "line",
          data: JSON.parse(item.axisYData),
          itemStyle: {
            normal: {
              color: item.platform == "WX" ? "#28C445" : "#06B4FD",
            },
          },
        });
      });

      this.initLineChart({
        typeXAxis: this.typeXAxis,
        seriesData: this.seriesData,
      });
    },
    initLineChart({ typeXAxis, seriesData }) {
      const chartDom = this.$refs.lineChart;
      const myChart = echarts.init(chartDom);
      const option = {
        title: {
          text: "",
        },
        grid: {
          //方法 1
          left: 15,
          right: 15,
          bottom: 0,
          top: 45,
          containLabel: true,
        },

        legend: {
          data: ["微信", "支付宝"],
        },
        tooltip: {
          trigger: "axis",
        },
        xAxis: {
          type: "category",
          data: typeXAxis,
        },
        yAxis: {
          type: "value",
        },
        series: seriesData,
      };

      myChart.setOption(option);
    },
  },
};
</script>
